export const links = [
    {
        id: 1,
        text: "home",
        url: "/",
    },
    {
        id: 2,
        text: "about",
        url: "/about",
    },
    {
        id: 3,
        text: "products",
        url: "/products",
    },
    {
        id: 4,
        text: "contact",
        url: "/contact",
    },
];

export const user_options = [
    {
        text: "My Account",
        url: "/account",
    },
];
